// SSR-safe network metadata. No reown/appkit imports here.
import { ROBINHOOD_CHAIN } from "@/config/robotdex";

export type NetworkMeta = {
  id: number;
  name: string;
  nativeCurrency: { name: string; symbol: string; decimals: number };
  blockExplorers?: { default: { name: string; url: string; apiUrl?: string } };
  rpcUrls: { default: { http: readonly string[] } };
};

export const networks: NetworkMeta[] = [
  {
    id: ROBINHOOD_CHAIN.id,
    name: ROBINHOOD_CHAIN.name,
    nativeCurrency: ROBINHOOD_CHAIN.nativeCurrency,
    rpcUrls: ROBINHOOD_CHAIN.rpcUrls,
    blockExplorers: ROBINHOOD_CHAIN.blockExplorers,
  },
  {
    id: 1,
    name: "Ethereum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: ["https://cloudflare-eth.com"] } },
    blockExplorers: { default: { name: "Etherscan", url: "https://etherscan.io" } },
  },
  {
    id: 56,
    name: "BNB Smart Chain",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: { default: { http: ["https://bsc-dataseed.binance.org"] } },
    blockExplorers: { default: { name: "BscScan", url: "https://bscscan.com" } },
  },
  {
    id: 8453,
    name: "Base",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: ["https://mainnet.base.org"] } },
    blockExplorers: { default: { name: "Basescan", url: "https://basescan.org" } },
  },
  {
    id: 42161,
    name: "Arbitrum One",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: ["https://arb1.arbitrum.io/rpc"] } },
    blockExplorers: { default: { name: "Arbiscan", url: "https://arbiscan.io" } },
  },
];
